import * as yup from 'yup';

/*
The validation rules are:
# Single row
 - requestDate is not required 
 - Completely empty row is allowed.
# Multiple rows
 - requestDate is required for every row, regardless of time.
*/

// Message is sent from json schema
const createServiceRequestRowSchema = messageFromSchema =>
  yup
    .object({
      requestDate: yup.string().nullable(),
      slotTypeCode: yup.string().nullable(),
    })
    .test(
      'request-date-conditional',
      messageFromSchema,
      function rowTest(value) {
        const rowCount = this.options?.context?.rowCount ?? 1;

        if (!value) return true;

        if (rowCount === 1) {
          if (!value?.requestDate) return true;
        }

        const { requestDate } = value;

        // Single row
        if (rowCount === 1) {
          if (!requestDate) {
            return this.createError({
              path: `${this.path}.requestDate`,
              message: messageFromSchema,
            });
          }
          return true;
        }

        // Multiple rows → every row needs date
        if (!requestDate) {
          return this.createError({
            path: `${this.path}.requestDate`,
            message: messageFromSchema,
          });
        }

        return true;
      },
    );

export default createServiceRequestRowSchema;
